import { Link } from "react-router-dom";

export default function ForbiddenPage() {
  return (
    <div className="bg-background border border-border rounded-lg p-8 max-w-md mx-auto text-center space-y-3">
      <div className="text-5xl font-bold text-amber-500">403</div>
      <h1 className="text-lg font-semibold">权限不足</h1>
      <p className="text-sm text-muted-foreground">
        你的角色没有访问此页面的权限。若需要更高权限，请联系管理员。
      </p>
      <Link
        to="/"
        className="inline-block mt-2 rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:opacity-90"
      >
        返回首页
      </Link>
    </div>
  );
}
